export const AUTHENTICATE_PATH = '/authenticate';
